import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BoSpinnerService, BoToastrService } from '../../../../../@core/shared';

import {
  ConsignmentActionsService,
  IConsignmentEdit, IConsignmentPod
} from '../../../../../@core/http/consignment-actions';
import {ExceptionCodeService} from '../../../../../@core/http/exception-codes';
import {ExceptionCodes} from '../../../../../@core/models/exception-codes';
import {environment} from '../../../../../environments/environment';
import {ConsignmentPodAttachmentTypeEnum} from './upload-attachment-file/consignment-pod-attachment-type.enum';
import {AdditionalDetailSimpleInfoInterface} from './interface/additional-detail-simple-info.interface';
import {API} from '../../../../../@core/http/config/api';
import {ConsignmentPodListUiModel, ConsignmentPodUiModel} from './ui-model/consignment-pod-list.ui-model';
import { tap } from 'rxjs/operators';

@Injectable()
export class ConsignmentPodService {
  constructor(private _exceptionCodeService: ExceptionCodeService,
              private httpClient: HttpClient,
              private toastService: ToastrService,
              private _spinner: BoSpinnerService,
              private consignmentActionsService: ConsignmentActionsService) {   
  }

  private consignmentPodListSubject: Subject<ConsignmentPodListUiModel[]> = new Subject();
  public consignmentPods = this.consignmentPodListSubject.asObservable();
  private currentConsignmentPodList: ConsignmentPodListUiModel[];

  private exceptionCodesListSubject: Subject<ExceptionCodes[]> = new Subject();
  private exceptionCodesList: ExceptionCodes[];

  private consignmentSubject: Subject<IConsignmentEdit> = new Subject();
  public consignment: Observable<IConsignmentEdit> = this.consignmentSubject.asObservable();


  private consignmentDetailsSubject: BehaviorSubject<AdditionalDetailSimpleInfoInterface[]> = new BehaviorSubject([]);
  public consignmentDetails = this.consignmentDetailsSubject.asObservable();

  private consignmentId;

  private pecCode: string = '';
  private pecCodeChange = new Subject<string>();
  private consignmentNumberChange = new Subject<number>();
  public consignmentIDNumber: number;

  getPECcode() {
    return this.pecCodeChange.asObservable();
  }

  setPECcode(pecCode: string) {
    this.pecCodeChange.next(pecCode);
  }
  getconsignmentNumber() {
    return this.consignmentNumberChange.asObservable();
  }

  setconsignmentNumber(consignmentNumber: number) {
    this.consignmentNumberChange.next(consignmentNumber);
  }
  storeConsignmentPod(consignmentId) {
    this.consignmentId = consignmentId;
    this.loadConsignmentPodList(this.consignmentId);
   
    this._exceptionCodeService.getExceptionCodes({PaginationType: -1},true).subscribe(observer => {
      this.exceptionCodesListSubject.next(observer.data);
      this.exceptionCodesList = observer.data || [];
    });
  }

  getRecipientEmails(consignmentNumber: number): Observable<string[]> {
    return this.httpClient.get<string[]>(API.CONSIGNMENT_POD.GET_RECIPIENT_EMAILS(consignmentNumber));
  }
  private async loadConsignmentFromServer(consignmentId): Promise<IConsignmentEdit> {
    return new Promise<IConsignmentEdit>((resolve, reject) => {
      this.consignmentActionsService.getConsignmentDataToEdit(consignmentId).subscribe(resolve, reject);
    });
  }

  getConsignmentDataToEdit(id: string): Observable<IConsignmentEdit> {
    return this.httpClient.get<IConsignmentEdit>(`${API.CONSIGNMENT.GET_ONE(id)}`);

  }


  sendPodEmail(data: any): Observable<any> {
    return this.httpClient.post(API.CONSIGNMENT_POD.SEND_POD_EMAIL, data);
  }

  private async loadConsignmentPodsFromServe(consignmentId): Promise<IConsignmentPod[]> {
    this.pecCode = '';
    return new Promise<IConsignmentPod[]>((resolve, reject) => {
      this.httpClient.get<IConsignmentPod[]>(API.CONSIGNMENT_POD.GET_BY_CONSIGNMENT(consignmentId)).subscribe(resolve, reject);
    });
  }


  async loadConsignmentPodList(consignmentId) {
    var consignment = null;
    await this.getConsignmentDataToEdit(consignmentId).subscribe(async (data) => {
      consignment = data;
      this.consignmentIDNumber = consignment.consignmentIDNumber;
      this.setconsignmentNumber(this.consignmentIDNumber);
      this.addDefaultDrop(consignment);

      this.pecCode = '';
      this.httpClient.get<IConsignmentPod[]>(API.CONSIGNMENT_POD.GET_BY_CONSIGNMENT(consignmentId)).subscribe((data1) => {
        var consignmentPods = data1;
        if (consignmentPods.length > 0) {
          this.pecCode = consignmentPods[consignmentPods.length - 1].pecCode;
          this.setPECcode(this.pecCode);
        }
        this.consignmentSubject.next(consignment);
        const consignmentPodUiModel = this.buildPodsUiModel(consignment, consignmentPods);
        this.consignmentPodListSubject.next(consignmentPodUiModel);
        this.currentConsignmentPodList = consignmentPodUiModel;
        const consignmentDetails = this.buildConsignmentDetails(consignment);
        this.consignmentDetailsSubject.next(consignmentDetails);
      });
    });
  }

  private buildPodsUiModel(consignment: IConsignmentEdit, consignmentPods: IConsignmentPod[]): ConsignmentPodListUiModel[] {
    const result: ConsignmentPodListUiModel[] = [];
    const additionalDetails = consignment.consignmentAddtionalDetails;

    additionalDetails.forEach(item => {
      const matchingPods = consignmentPods.filter(p => p.consignmentAddtionalDetailID === item.id);
      result.push({
        consignmentAdditionalDetailId: item.id,
        companyName: item.companyName,
        postCode: item.postCode,
        consignmentPods: matchingPods.map(pod => {
          return {...pod, exceptionCost: 0, exceptionPrice: 0};
        }),
      });
    });
    return result;
  }

  private addDefaultDrop(consignment: IConsignmentEdit) {
    const consignmentDelivery = {
      consignmentID: consignment.id,
      id: null,
      companyName: consignment.deliveryCompanyName,
      postCode: consignment.deliveryPostCode
    };
    consignment.consignmentAddtionalDetails.splice(0, 0, consignmentDelivery);
  }
  private buildConsignmentDetails(consignment: IConsignmentEdit) {
    return consignment.consignmentAddtionalDetails.map(
      ad => {
        const { id, companyName, postCode } = ad;
        return {
          id,
          companyName,
          postCode
        };
      }
    );
  }

  getConsignmentInfo(): Promise<IConsignmentEdit> {
    return this.loadConsignmentFromServer(this.consignmentId);
  }

  async getExceptionCodes(): Promise<ExceptionCodes[]> {
    if (this.exceptionCodesList) {
      return this.exceptionCodesList;
    }
    return new Promise<ExceptionCodes[]>((resolve, reject) => {
      this.exceptionCodesListSubject.asObservable().subscribe(resolve, reject);
    });
  }

  async createConsignmentPod(podForm: any, podAttachs: any[], invoiceAttachs: any[]): Promise<boolean> {
    const formData = new FormData();
    formData.append('model', JSON.stringify(podForm.value));

    for (let i = 0; i < podAttachs.length; i++) {
      formData.append(`podAttachment_${i}`, podAttachs[i].file, podAttachs[i].fileName);
    }

    for (let i = 0; i < invoiceAttachs.length; i++) {
      formData.append(`invoiceAttachment_${i}`, invoiceAttachs[i].file, invoiceAttachs[i].fileName);
    }

    const createPodRequest = new Promise<boolean>((resolve, reject) => {
      this.httpClient.post<any>(API.CONSIGNMENT_POD.CREATE, formData)
        .subscribe((newPod) => {
          const newPodUiModel: ConsignmentPodUiModel = {...newPod, exceptionCost: 0, exceptionPrice: 0};
          const podList = this.currentConsignmentPodList
            .find(detail => detail.consignmentAdditionalDetailId === newPodUiModel.consignmentAddtionalDetailID);
          if (podList) {
            podList.consignmentPods.push(newPodUiModel);
           // this.pecCode = newPodUiModel.pecCode; 
          }
          this.consignmentPodListSubject.next(this.currentConsignmentPodList);
          resolve(true);
          this.setPECcode(newPodUiModel.pecCode);
        }, reject);
    });
    return await createPodRequest;
  }

  emailToCustomer(isAll = false) {
    this.toastService.success('Coming soon','Success',{
      timeOut: 2000,
      toastClass: 'toast toast-default-font'
    });
  }

  updateConsignmentPod(podForm, id): Promise<boolean> {
    const formData = new FormData();
    formData.append('model', JSON.stringify(podForm.value));
    return new Promise<boolean>((resolve, reject) =>
      this.httpClient.patch(API.CONSIGNMENT_POD.UPDATE(id), formData).subscribe(resolve, reject)
    );
  }

  deleteConsignmentPod(id) {
    this.httpClient.delete(API.CONSIGNMENT_POD.UPDATE(id)).subscribe(() => {
      for (const podList of this.currentConsignmentPodList) {
        const index = podList.consignmentPods.findIndex(p => p.id === id);
        if (index > -1) {
          podList.consignmentPods.splice(index, 1);
          break;
        }
      }
      this.consignmentPodListSubject.next(this.currentConsignmentPodList);
    });
  }

  uploadAttachment(type, selectedFile, podId): Promise<string> {
    const apiPath = type === ConsignmentPodAttachmentTypeEnum.Pod ?
      API.CONSIGNMENT_POD.UPDATE_POD_ATTACHMENT(podId) : API.CONSIGNMENT_POD.UPDATE_INVOICE_ATTACHMENT(podId);
    const formData = new FormData();
    formData.append('attachment', selectedFile.file, selectedFile.fileName);
    return new Promise<string>((resolve, reject) => {
      this.httpClient.patch<string>(apiPath, formData).subscribe(resolve, reject);
    });
  }

  deleteAttachment(type: number, podId: string, mediaObjectId: string): Promise<boolean> {
    const apiPath = type === ConsignmentPodAttachmentTypeEnum.Pod ?
      API.CONSIGNMENT_POD.DELETE_POD_ATTACHMENT(podId, mediaObjectId) : API.CONSIGNMENT_POD.DELETE_INVOICE_ATTACHMENT(podId, mediaObjectId);
    return new Promise<boolean>((resolve, reject) => {
      this.httpClient.delete<boolean>(apiPath).subscribe(resolve, reject);
    });
  }

  getPreviewUrl(type: ConsignmentPodAttachmentTypeEnum, podId: string, mediaObjectId: string) {
    if (type === ConsignmentPodAttachmentTypeEnum.Pod) {
      return `${environment.baseUrl}/api/consignmentPod/${podId}/podAttachment/${mediaObjectId}`;
    } else {
      return `${environment.baseUrl}/api/consignmentPod/${podId}/invoiceAttachment/${mediaObjectId}`;
    }
  }

  showConsignmentPod(type: ConsignmentPodAttachmentTypeEnum, podId: string, mediaObjectId: string) {
    var url = '';
    if (type === ConsignmentPodAttachmentTypeEnum.Pod) {
      url = `${environment.baseUrl}/api/consignmentPod/${podId}/podAttachment/${mediaObjectId}`;
    } else {
      url = `${environment.baseUrl}/api/consignmentPod/${podId}/invoiceAttachment/${mediaObjectId}`;
    }

    return this.httpClient.get(url, { responseType: 'blob' }).pipe(tap(() => this._spinner.hide()));
  }
}
